import IdealStudio from "../editor/main";
import BasePlugin from "./base_plugin";
import { TRANSLATED_LANGUAGES } from "../../common/content_language";

export default function () {
  let pluginInstancesList = {};
  return {
    get: function (name) {
      return pluginInstancesList[name];
    },
    getAll: function () {
      return pluginInstancesList;
    },
    add: function (name, lang) {
      let basePlugin = new BasePlugin();
      IdealStudio.Visor.Plugins[name] = require("./../../plugins/" + name + "/" + name)[name](
        basePlugin
      );
      let config = IdealStudio.Visor.Plugins[name].getConfig();
      try {
        IdealStudio.Visor.Plugins[name] = require("./../../plugins/" + name + "/visor/" + name)[
          name
        ](basePlugin);
      } catch (e) {}
      IdealStudio.Visor.Plugins[name].getConfig = () => {
        return config;
      };

      basePlugin.create(IdealStudio.Visor.Plugins[name]);
      basePlugin.init();
      basePlugin.getConfig = () => {
        return config;
      };
      basePlugin.getLocales(lang);
      TRANSLATED_LANGUAGES.forEach((l) => basePlugin.getLocales(l));
      // basePlugin.init();
      pluginInstancesList[name] = basePlugin;
    },
  };
}
